import React, { useState } from 'react';
import { Button, Divider, Form, Input, InputNumber, Modal, Typography } from 'antd';
import { notification } from 'antd';

import { useDispatch, useSelector } from 'react-redux';
import { actions } from '@/core/store';
import LoadingCover from '../../components/LoadingCover';
const { Text } = Typography;
import ReCAPTCHA from "react-google-recaptcha";


const ContactModal = ({ open, handleClose }) => {


    const captchaSiteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;
    const captchaSecretKey = import.meta.env.VITE_RECAPTCHA_SECRET_KEY;

    const recaptchaRef = React.useRef();

    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const pending = useSelector(state => state.auth.pending);
    const loadContactModal = useSelector(state => state.auth.loadContactModal);

    const handleSubmitContact = async (values) => {

        const captchaValue = recaptchaRef.current.getValue();
        //console.log(captchaValue);

        if (!captchaValue) {
            notification.destroy();
            notification['error']({
                duration: 3,
                message: 'Please verify the reCAPTCHA',
                description: 'Please verify the reCAPTCHA to proceed.',
            });
            return
        } else {
            // proceed with form submission
        }

        dispatch(actions.auth.submitContactForm(values, captchaValue));
    };

    const closeModal = () => {
        if (pending) {
            return false;
        }
        dispatch(actions.auth.setState({ loadContactModal: false }));
        form.resetFields();
        handleClose();
    };

    const handleChange = (e) => {
        const inputVal = e.target.value;
        const formatted = formatPhoneNumber(inputVal);
        form.setFieldsValue({ phone: formatted });
    };

    const formatPhoneNumber = (value) => {
        const digits = value.replace(/\D/g, '').slice(0, 10); // Only keep numbers, max 10 digits
        const len = digits.length;

        if (len <= 3) return digits;
        if (len <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
        return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
    };

    const onChangeCAPTCHA = (v) => {
        //console.log('onChangeCAPTCHA')
        //console.log(v)
    }

    const onCAPTCHALoaded = (e) => {
        //console.log('onCAPTCHALoaded')
        //console.log(e)
    }


    return (
        <>
            <Modal
                title={'Contact Form'}
                visible={open}
                centered
                onCancel={closeModal}
                maskClosable={false}
                footer={null}
            >
                {
                    pending &&
                    <LoadingCover />
                }
                <Form
                    className="ts_form_margin"
                    name="submit_contact"
                    form={form}
                    onFinish={handleSubmitContact}
                >
                    <Form.Item
                        name="notes"
                        rules={[{ required: true, message: 'Please provide a message' }]}
                    >
                        <Input.TextArea
                            placeholder="Please provide a brief description of how we can help you *"
                            className="ts_padding"
                            disabled={pending}
                            rows={8}
                        />

                    </Form.Item>

                    <Form.Item
                        name="firstName"
                        rules={[{ required: true, message: 'Please provide a first name' }]}
                    >
                        <Input placeholder="First Name" className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Form.Item
                        name="lastName"
                        rules={[{ required: true, message: 'Please provide a last name' }]}
                    >
                        <Input placeholder="Last Name" className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Form.Item
                        name="company"
                        rules={[{ required: true, message: 'Please provide the name of the company' }]}
                    >
                        <Input placeholder="Company" className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Form.Item
                        name="email"
                        rules={[{ required: true, message: 'Please provide an email' }]}
                    >
                        <Input placeholder="Business Email" className="ts_padding" disabled={pending} />
                    </Form.Item>

                    <Form.Item
                        name="phone"
                        rules={[
                            { required: true, message: 'Please provide a phone number' },
                        ]}
                    >
                        <Input
                            addonBefore='Phone Number'
                            onChange={handleChange}
                            maxLength={12}
                            style={{ width: '100%' }}
                            placeholder="000-000-0000"
                            disabled={pending}
                        />
                    </Form.Item>

                    <Divider />
                    <div
                        className='reset-pw-captcha-parent'
                        style={{
                            display: 'flex',
                            justifyContent: 'center'
                        }}
                    >
                        <ReCAPTCHA
                            ref={recaptchaRef}
                            sitekey={captchaSiteKey}
                            onChange={onChangeCAPTCHA}
                            asyncScriptOnLoad={onCAPTCHALoaded}
                            size={'normal'}
                        />
                    </div>
                    <Divider />

                    <Button
                        type="primary"
                        htmlType="submit"
                        className="ts_margin_left"
                        disabled={pending}
                    >
                        Submit
                    </Button>

                    <Button
                        onClick={closeModal}
                        className="ts_margin_left"
                        disabled={pending}
                    >
                        Cancel
                    </Button>

                </Form>
            </Modal>

        </>
    );
};



export default ContactModal;
